import { render, staticRenderFns } from "./AgentBrief.vue?vue&type=template&id=6c6c7174&scoped=true"
import script from "./AgentBrief.vue?vue&type=script&lang=js"
export * from "./AgentBrief.vue?vue&type=script&lang=js"
import style0 from "./AgentBrief.vue?vue&type=style&index=0&id=6c6c7174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c7174",
  null
  
)

export default component.exports